import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { GradButton } from "@/components/erp";
import { FormDialog } from "@/components/FormDialog";
import { Tablo, sayi } from "@/components/kalip/Tablo";
import { SINIF } from "@/components/kalip/KalipKartlari";
import api, { errMsg } from "@/lib/api";

const Liste = ({ yaz, url, prefix, baslik, aciklama, fields, cols, bos, ad }) => {
  const [list, setList] = useState([]);
  const [dlg, setDlg] = useState(null);
  const load = useCallback(async () => setList((await api.get(url)).data), [url]);
  useEffect(() => { load(); }, [load]);
  const kaydet = async (f) => { if (f.id) await api.put(`${url}/${f.id}`, f); else await api.post(url, f); toast.success("Kaydedildi"); load(); };
  const sil = async (r) => { try { await api.delete(`${url}/${r.id}`); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid={`${prefix}-liste`}>
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <p className="text-xs text-muted-foreground max-w-2xl">{aciklama}</p>
        {yaz && <GradButton className="ml-auto" data-testid={`${prefix}-ekle`} onClick={() => setDlg(bos)}><Plus className="w-4 h-4" />{baslik}</GradButton>}
      </div>
      <Tablo testid={`${prefix}-tablo`} cols={cols} rows={list} yaz={yaz} onEdit={setDlg} onDelete={sil} />
      {dlg && <FormDialog prefix={prefix} title={dlg.id ? `${ad} düzenle` : baslik} fields={fields} initial={dlg} onSubmit={kaydet} onClose={() => setDlg(null)} />}
    </div>
  );
};

export const Kazanlar = ({ yaz }) => (
  <Liste yaz={yaz} url="/kazanlar" prefix="kazan" baslik="Yeni kazan" ad="Kazan"
    aciklama="Her kazanın günde kaç döngü (pişirme) yaptığı ve bir döngüde kaç kalıp aldığı. Kazan kontrollü profillerde termin, kazanın günlük kalıp-çevrim kapasitesine göre ayrıca sınırlanır."
    bos={{ ad: "", kod: "", gunluk_dongu: 4, kalip_kapasitesi: 10, aktif: true, aciklama: "" }}
    fields={[{ k: "ad", label: "Kazan adı *" }, { k: "kod", label: "Kod" }, { k: "gunluk_dongu", label: "Günlük döngü sayısı *", type: "number" },
      { k: "kalip_kapasitesi", label: "Bir döngüde alınan kalıp *", type: "number" }, { k: "aktif", label: "Aktif", type: "switch" }, { k: "aciklama", label: "Açıklama", wide: true }]}
    cols={[["Kazan", (r) => <div><div className="font-medium">{r.ad}</div><div className="text-[11px] font-mono text-muted-foreground">{r.kod}</div></div>],
      ["Döngü/gün", (r) => sayi(r.gunluk_dongu), "text-right"], ["Kalıp/döngü", (r) => sayi(r.kalip_kapasitesi), "text-right"],
      ["Günlük kalıp-çevrim", (r) => <b data-testid={`kazan-kapasite-${r.kod || r.id}`}>{sayi(r.gunluk_dongu * r.kalip_kapasitesi)}</b>, "text-right"]]} />
);

export const DonguProfilleri = ({ yaz }) => (
  <Liste yaz={yaz} url="/dongu-profilleri" prefix="profil" baslik="Yeni döngü profili" ad="Profil"
    aciklama="Bir kalıbın günde kaç kez kazana girebildiği. Silikon hortumda B/BK/K/D/DK için 4, M ailesi için 2 döngü varsayılan olarak hazırdır."
    bos={{ kod: "", ad: "", sinif: "genel", gunluk_dongu: 4, azami_dongu: 4, kazan_kontrolu: true, aktif: true, aciklama: "" }}
    fields={[{ k: "kod", label: "Profil kodu *" }, { k: "ad", label: "Profil adı *" },
      { k: "sinif", label: "Profil sınıfı", type: "select", options: Object.entries(SINIF).map(([value, label]) => ({ value, label })) },
      { k: "gunluk_dongu", label: "Varsayılan günlük döngü *", type: "number" }, { k: "azami_dongu", label: "Teknik azami günlük döngü", type: "number" },
      { k: "kazan_kontrolu", label: "Kazan darboğazı kontrol edilsin", type: "switch" }, { k: "aktif", label: "Aktif", type: "switch" }, { k: "aciklama", label: "Açıklama", wide: true }]}
    cols={[["Kod", (r) => <span className="font-mono text-xs">{r.kod}</span>], ["Profil", (r) => r.ad], ["Sınıf", (r) => SINIF[r.sinif]],
      ["Normal", (r) => sayi(r.gunluk_dongu), "text-right"], ["Azami", (r) => (r.azami_dongu ? sayi(r.azami_dongu) : "—"), "text-right"],
      ["Kazan kontrolü", (r) => (r.kazan_kontrolu ? "Evet" : "Hayır")]]} />
);
